"use client";

import { faPen } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { serialize } from "@tosize/tosize-furniture-configurator/src/components/renderer/data";
import { useState } from "react";
import type { ServerFurnitureConfiguratorProps } from "~/components/configurator/utilities";
import {
	BaseFurnitureConfigurator,
	type BaseFurnitureConfiguratorProps,
} from "../configurator/furniture/BaseFurnitureConfigurator";

interface DiyCanvasViewProps extends ServerFurnitureConfiguratorProps {
	title: string;
	item: BaseFurnitureConfiguratorProps["item"];
}

export function DiyCanvasView({ title, item, ...props }: DiyCanvasViewProps) {
	const [orderData, setOrderData] = useState(item?.orderData ?? undefined);

	return (
		<div className="relative aspect-video h-full w-full overflow-hidden">
			<BaseFurnitureConfigurator
				{...props}
				item={{ ...item, orderData }}
				onStoreChange={(store) => setOrderData(serialize(store))}
				title={title}
				mode="add"
				variant="dialogButton"
			>
				<button
					type="button"
					className="absolute top-2 right-2 z-1 flex h-6 w-6 items-center justify-center rounded-full bg-secondary enter:bg-secondary-medium text-white text-xs shadow-secondary focus:outline-none motion-safe:transition-colors sm:h-7 sm:w-7 sm:text-sm lg:h-8 lg:w-8 lg:text-base"
				>
					<FontAwesomeIcon icon={faPen} fixedWidth />
				</button>
			</BaseFurnitureConfigurator>

			<BaseFurnitureConfigurator
				{...props}
				item={{ ...item, orderData }}
				mode="view"
				variant="default"
			/>
		</div>
	);
}
